import React, { useState } from 'react';
import BackgroundElements from './BackgroundElements';
import CTASection from './CTASection';
import DataLifecycleSection from './DataLifecycleSection';
import Footer from './Footer';
import HeroSection from './HeroSection';
import SolutionDetailsSection from './SolutionDetailsSection';
import ValuePropositionSection from './ValuePropositionSection';

const HomePage = ({ onNavigate }) => {
    const [activeStep, setActiveStep] = useState(0);

    return (
        <div className="min-h-screen bg-slate-900 text-white">
            {/* Background Elements */}
            <BackgroundElements />

            {/* Hero Section */}
            <HeroSection />

            {/* Data Lifecycle Section */}
            <DataLifecycleSection
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                onNavigate={onNavigate}
            />

            {/* Selected Solution Details */}
            <SolutionDetailsSection
                activeStep={activeStep}
                onNavigate={onNavigate}
            />

            {/* Value Proposition Section */}
            <ValuePropositionSection />

            {/* Call to Action Section */}
            <CTASection onNavigate={onNavigate} />

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default HomePage;